import gql from "graphql-tag";


export default function(params){
    return gql`
            mutation {
                updateParkingSpace(
                    id: "${params.id}"
                    garage_id: "${params.garage_id}"
                    number: "${params.number}"
                    active: ${params.active}
                    type: "${params.type}"
                    level: "${params.level}"
                    state: "${params.state}"
                    stack_parking: ${params.stack_parking}
                    height: ${params.height}
                    width: ${params.width}
                    length: ${params.length}
                ) {
                    errors
                    parkingSpace {
                        id
                        number
                        active
                        type
                        level
                        state
                        stack_parking
                        state_changed
                        width
                        height
                        length
                    }
                }
            }`;
}
